/**
 * SCWT-PM-V2 Phase 3 — PWS Partner page to invite Property Managers.
 * Route: /partner/property-managers  (visible when property_manager_v2 flag ON).
 */
import { PartnerShell } from "@/pages/partner/Dashboard";
import PwsInviteAPmPanel from "@/components/pm/PwsInviteAPmPanel";
import { FeatureGate } from "@/lib/useFeature";

export default function PartnerPropertyManagers() {
  return (
    <PartnerShell active="Property Managers">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-slate-900">Property Managers</h1>
          <p className="text-sm text-slate-500 mt-1">
            Invite local real-estate agencies to onboard for free onto the
            Aware Property Manager Programme.
          </p>
        </div>
        <FeatureGate flag="property_manager_v2"
                      fallback={
                        <div className="bg-white border border-amber-200 border-dashed rounded-2xl p-8 text-center text-sm text-amber-800">
                          The Property Manager Programme isn't turned on for
                          your account yet. Contact Aware to join the pilot
                          cohort.
                        </div>
                      }>
          <PwsInviteAPmPanel />
        </FeatureGate>
      </div>
    </PartnerShell>
  );
}
